// Route wrappers binding the shared staff-task screens into each shell.
import { StaffProjectDetail } from './StaffProjectDetail'
import { StaffTaskDetail } from './StaffTaskDetail'
import { StaffTasksPage } from './StaffTasksPage'

export const AdminStaffTasks = () => <StaffTasksPage shell="admin" />
export const AdminStaffTaskDetail = () => <StaffTaskDetail shell="admin" />
export const SellerStaffTasks = () => <StaffTasksPage shell="seller" />
export const SellerStaffTaskDetail = () => <StaffTaskDetail shell="seller" />
export const SupplyStaffTasks = () => <StaffTasksPage shell="supply" />
export const SupplyStaffTaskDetail = () => <StaffTaskDetail shell="supply" />
export const AdminStaffProjectDetail = () => <StaffProjectDetail shell="admin" />
export const SellerStaffProjectDetail = () => <StaffProjectDetail shell="seller" />
export const SupplyStaffProjectDetail = () => <StaffProjectDetail shell="supply" />
